export const COMPANY_ID = "Black Tree Gaming Ltd.";
export const NEXUSMODS_EXT_ID = "Nexus Mods";
